export default __webpack_public_path__ + "static/media/Scholar's Leggings of the Moon.e9d6001d.jpg";